export const DATEPICKER_FORMAT = 'YYYY-MM-DD';
// Feature flags
export const MULTIPLE_PROVIDER_QUOTES = true;

export const reviewsPerPage = 20;
